export default "__VITE_ASSET__c8XJXKQM__"